import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import "lib-flexible/flexible";

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()

// vue-resource安装
import VueResource from 'vue-resource'
Vue.use(VueResource)

// clipboard安装
import clipboard from 'clipboard';
//注册到vue原型上
Vue.prototype.clipboard = clipboard;

// import axios from 'axios'
// axios.defaults.baseURL='https://api.qcplay.com'
// Vue.prototype.axios=axios 

// mint-ui安装 和 样式导入
import Mint from 'mint-ui';
Vue.use(Mint);
import 'mint-ui/lib/style.css';

// 每个子页面添加标题
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

// animate动画库安装
import animated from 'animate.css' 
Vue.use(animated)

// 引入html2canvas
import html2canvas from 'html2canvas'

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

// 设置请求的根路径
Vue.http.options.root = 'https://api.qingcigame.com' 
// Vue.http.options.root = 'https://qcplay.com'
// 全局设置 post 的时候表单数据格式组织形式
Vue.http.options.emulateJSON = true;
Vue.http.options.credentials = true;

// 转盘插件
import LuckDraw from 'vue-luck-draw'
Vue.use(LuckDraw)

import Meta from 'vue-meta'
Vue.use(Meta)

// 导入初始css
import './css/reset.min.css'

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js